import { render, staticRenderFns } from "./choujiang.vue?vue&type=template&id=16c878f8&scoped=true&"
import script from "./choujiang.vue?vue&type=script&lang=js&"
export * from "./choujiang.vue?vue&type=script&lang=js&"
import style0 from "./choujiang.scss?vue&type=style&index=0&id=16c878f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c878f8",
  null
  
)

export default component.exports